import * as _ from 'immutable'
import setLocation from '../action/creators/set-location'
import {put} from 'redux-saga/effects'

export default function* (history) {
  yield put(setLocation(_.fromJS({action: history.action, location: history.location})))
}
